export default "__VITE_ASSET__CSJWl6Wo__"